import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    fetchAllClientsFiltered,
    selectClients,
    selectClientsLoadingStatus,
    selectClientsPageInfo,
    resetClientsState,
} from 'features/clients/clientsSlice';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import { ClientTable } from './ClientTable';
import { activateLoading, deactivateLoading } from 'GeminiViewerComponent/features/globals/loadingProgressSlice';

const ClientManagementTab = () => {
    const dispatch = useDispatch();
    const ref = useRef(false);
    const Clients = useSelector(selectClients);
    const ClientStatus = useSelector(selectClientsLoadingStatus);
    const ClientPageInfo = useSelector(selectClientsPageInfo);
    const [ClientPayload, setClientPayload] = useState({
        sorts: 'display_name',
        filters: 'is_active==true',
    });
    const [sortBy, setSortBy] = useState('display_name');
    const [sortDirection, setSortDirection] = useState('ASC');

    const getClientsData = async (payload) => {
        dispatch(activateLoading());
        await dispatch(fetchAllClientsFiltered({ ...payload }));
        dispatch(deactivateLoading());
    };

    useEffect(() => {
        if (ref.current === true) {
            getClientsData({ ...ClientPayload });
        }
    }, [ClientPayload]);

    useEffect(() => {
        return async () => {
            await dispatch(resetClientsState());
        };
    }, []);

    useEffect(() => {
        if (ClientStatus === LoadingStatus.Idle) {
            getClientsData({ ...ClientPayload });
        }
        ref.current = true;
    }, [ClientStatus, dispatch]);

    const setSorting = (_sortBy, _sortDirection) => {
        setSortBy(_sortBy);
        setSortDirection(_sortDirection);
        setClientPayload({
            ...ClientPayload,
            sorts: `${_sortDirection === 'ASC' ? '' : '-'}${_sortBy}`,
        });
    };

    return (
        <ClientTable
            clients={Clients}
            pageInfo={ClientPageInfo}
            ClientPayload={ClientPayload}
            setClientPayload={setClientPayload}
            sortDirection={sortDirection}
            sortBy={sortBy}
            handleSort={(_sortBy, _sortDirection) => setSorting(_sortBy, _sortDirection)}
        />
    );
};

export { ClientManagementTab };
